import { Component } from '@angular/core';

@Component({ standalone: false, selector: 'app-full-page-template',
  templateUrl: './full-page-template.component.html',
  styleUrls: ['./full-page-template.component.scss'],
})
export class FullPageTemplateComponent {
}
